import { FC, ReactNode } from "react";
import { FormControl, FormLabel, Typography, useTheme } from "@mui/material";
interface FormBoarderRowProps {
  key: number;
  label: string;
  children: ReactNode;
}
export const FormBoarderRow: FC<FormBoarderRowProps> = ({
  key,
  label,
  children
}) => {
  const theme = useTheme();
  return <FormControl key={`form-boarder-row-${key}`} fullWidth component="fieldset" sx={{
    border: "1px solid #ccc",
    borderRadius: 0.5,
    ml: 2,
    mb: 3,
    px: 1,
    py: 3,
    position: "relative"
  }} data-sentry-element="FormControl" data-sentry-component="FormBoarderRow" data-sentry-source-file="index.tsx">
			<FormLabel component="legend" sx={{
      px: 1,
      top: 0,
      position: "absolute",
      color: theme.palette.text.primary,
      transform: "translateY(-50%)",
      backgroundColor: theme.palette.background.paper
    }} data-sentry-element="FormLabel" data-sentry-source-file="index.tsx">
				<Typography variant="h6" data-sentry-element="Typography" data-sentry-source-file="index.tsx">{label}</Typography>
			</FormLabel>
			{children}
		</FormControl>;
};